var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.className, 'heading flex align-center']},[_c('h3',[_vm._v(_vm._s(_vm.heading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }